module.exports = __webpack_public_path__ + "static/media/payment-method-1.59ff7e32.svg";